module.exports = __webpack_public_path__ + "static/media/STHiFi3.f3b229c4.png";